import { TaxRate } from '../../../common/models/tax-rate';

export interface InvoiceGenericItem {
    id: number;
    position: number;
    price?: number;
    tax: number;
    discount?: number;
    taxRate: TaxRate;
    title: string;
    description?: string;
    quantity: number;
    type: InvoiceGenericItemType;
}

export enum InvoiceGenericItemType {
    Surcharge = 'SURCHARGE',
    ShippingCosts = 'SHIPPING_COSTS',
}
